export const OfficeReportsState = {
	url: '/reports',
	title: 'Office Reports',
	template: '<office-reports-page></office-reports-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeDataReportsPageMod" */
			'@Containers/office-reports-page/office-reports-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
